export const INITIAL_STATUS_CARDS_RECEIVED = "INITIAL_STATUS_CARDS_RECEIVED";
export const STATUS_CARD_UPDATE_RECEIVED = "STATUS_CARD_UPDATE_RECEIVED";
export const STATUS_CARD_REMOVED = "STATUS_CARD_REMOVED";
